// extracted by mini-css-extract-plugin
module.exports = {"moreInfoTag":"styles_moreInfoTag__3O5yU"};